export const SearchModelData = function () {
  return {
    countryId: '',
    advanceSearchList: [],
    textSearchList: [],
    checkBookMarkSearchAPI: false
  }
}
